export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["error"] = "error";
    Variant["success"] = "success";
    Variant["loading"] = "loading";
    Variant["info"] = "info";
    Variant["plain"] = "plain";
    Variant["warning"] = "warning";
    return Variant;
}({});
export var ToastPlacement = /*#__PURE__*/ function(ToastPlacement) {
    ToastPlacement["top"] = "top";
    ToastPlacement["bottom"] = "bottom";
    return ToastPlacement;
}({});
